import type { OAISchema } from '~/types/openapi';

export const SHOPPING_CARD_ITEM_STATUS_MESSAGE: Record<
  Required<OAISchema['MarketShoppingCartItemResponseV2']>['status'],
  string
> = {
  NORMAL: '정상',
  OUT_OF_STOCK: '재고부족',
  DISCONTINUED: '판매 중단',
  UNDELIVERABLE: '배송 불가 지역',
  INDIVIDUAL_QUANTITY_LIMIT_EXCEEDED: '최대 구매 수량 초과',
  UNSATISFIED_MINIMUM_ORDER_QUANTITY: '최소 구매 수량 미달',
  UNSATISFIED_ORDERABLE_QUANTITY: '최대 구매 수량 초과',
  LESS_QUANTITY_THAN_ITEM_QUANTITY: '구매 수량보다 재고가 적음',
  ALREADY_ORDERED_FIRST_ORDER_PRODUCT: '첫구매 상품 중복구매 불가',
  ALREADY_ORDERED_VENDOR_FIRST_ORDER_PRODUCT:
    '입점사 첫구매 상품 중복구매 불가',
  ALREADY_ORDERED_CASHNOTE_PLUS_100_DEAL: '100원딜 첫구매 상품 중복구매 불가',
};
